import bigDecimal from 'js-big-decimal';

import getFieldValues from './getFieldValues';

import {
  MATH_OPERATION_SUM,
  MATH_ROUND,
} from '../../../modules/FormBuilder/constants/constants';

const toNumber = value => new bigDecimal(isNaN(value) ? 0 : value);

export const applyRounding = (props, value) => {
  const { options } = props;
  const { rounding } = options;
  return rounding === MATH_ROUND ? value.round(2) : value.round();
};

const computeMathFieldValue = props => {
  const { options } = props;
  const { operands, operation } = options;
  let totalValues = 0;
  const total = operands?.reduce((tot, op) => {
    const _values = getFieldValues(props, op);
    const values = _values.filter(v => !isNaN(v) && !isNaN(parseFloat(v)));
    totalValues += values.length;
    return values.reduce(
      (totValues, value) => totValues.add(toNumber(value)),
      tot
    );
  }, new bigDecimal(0));
  let result;
  if (operation === MATH_OPERATION_SUM) {
    result = total;
  } else {
    result =
      totalValues > 0 ? total.divide(new bigDecimal(totalValues)) : undefined;
  }
  const rounded =
    result !== undefined ? applyRounding(props, result) : undefined;
  return rounded !== undefined ? rounded.getValue() : undefined;
};

export default computeMathFieldValue;
